module.exports = __webpack_public_path__ + "img/img_title_advantage_02.da3e3bef.png";